import { render, staticRenderFns } from "./Layout.vue?vue&type=template&id=37b6889e&scoped=true"
import script from "./Layout.vue?vue&type=script&lang=js"
export * from "./Layout.vue?vue&type=script&lang=js"
import style0 from "./Layout.vue?vue&type=style&index=0&id=37b6889e&prod&lang=less"
import style1 from "./Layout.vue?vue&type=style&index=1&id=37b6889e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b6889e",
  null
  
)

export default component.exports